<template>
  <div class="page-wrapper">
    <div class="index-container">
      <CustomNavbar :current-nav-item="currentNavItem" :is-playing="isPlaying" @nav-click="selectNavItem"
        @toggle-music="togglePlayPause" class="left-nav" />

      <div class="main-content">
        <homepage v-if="currentNavItem === 'home' || currentNavItem === 'homepage'" />
        <OfficialLive2d v-else-if="currentNavItem === 'officialLive2d'" />
        <FanmadeLive2d v-else-if="currentNavItem === 'fan-made-live2d'" />
        <Playlist v-else-if="currentNavItem === 'playlist'" />
        <CalculateGiftPoints v-else-if="currentNavItem === 'calculate'" />
        <Tutorial v-else-if="currentNavItem === 'tutorial'" />
        <Rules v-else-if="currentNavItem === 'rules'" />
        <div v-else>
          <div class="content-area">
            <h2>{{ currentTitle }}</h2>
            <div class="content-detail">
              <div v-if="currentContent && currentContent.image" class="image-container">
                <img :src="currentContent.image" :alt="currentTitle">
              </div>
              <div v-if="currentContent && currentContent.description" class="description">
                <p>{{ currentContent.description }}</p>
              </div>
              <div v-if="currentContent && currentContent.details" class="details">
                <h3>详细信息</h3>
                <ul>
                  <li v-for="(detail, key) in currentContent.details" :key="key">
                    <strong>{{ key }}：</strong>{{ detail }}
                  </li>
                </ul>
              </div>
              <div v-if="!currentContent || !currentContent.description" class="empty-content">
                <i class="el-icon-picture-outline"></i>
                <p>选择左侧菜单查看皮套详情</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomNavbar from './CustomNavbar.vue'
import homepage from './homepage.vue'
import OfficialLive2d from './officialLive2d.vue'
import FanmadeLive2d from './fanmadeLive2d.vue'
import Playlist from './playlist.vue'
import CalculateGiftPoints from './CalculateGiftPoints.vue'
import Rules from './rules.vue'
import Tutorial from './tutorial.vue'

export default {
  components: {
    CustomNavbar,
    homepage,
    OfficialLive2d,
    FanmadeLive2d,
    Playlist,
    CalculateGiftPoints,
    Rules,
    Tutorial,
  },
  data() {
    return {
      currentNavItem: 'homepage',
      isPlaying: false,
      audioContext: null,
      autoplayAttempted: false
    }
  },
  computed: {
    currentTitle() {
      const navItems = [
        { id: 'homepage', text: '首页' },
        { id: 'officialLive2d', text: '官方皮套' },
        { id: 'fan-made-live2d', text: '饭制皮套' },
        { id: 'playlist', text: '歌单' },
        { id: 'calculate', text: '礼物积分计算器' },
      ];
      const currentItem = navItems.find(item => item.id === this.currentNavItem)
      return currentItem ? currentItem.text : '内容详情'
    },
    currentContent() {
      return null
    }
  },
  mounted() {
    this.initAudioContext();
    this.tryAutoPlay();
    document.addEventListener('click', this.handleUserInteraction);
    document.addEventListener('keydown', this.handleUserInteraction);
    document.addEventListener('touchstart', this.handleUserInteraction);
    document.addEventListener('mousemove', this.handleUserInteraction, { once: true });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleUserInteraction);
    document.removeEventListener('keydown', this.handleUserInteraction);
    document.removeEventListener('touchstart', this.handleUserInteraction);
    if (this.audioContext) {
      this.audioContext.close();
    }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
      const mainContent = document.querySelector('.main-content');
      if (mainContent) mainContent.scrollTop = 0;
    }
  },
  methods: {
    initAudioContext() {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (AudioContext) {
          this.audioContext = new AudioContext();
        }
      } catch (error) {
        console.log('无法初始化AudioContext:', error);
      }
    },
    tryAutoPlay() {
      if (this.autoplayAttempted) return;
      this.autoplayAttempted = true;
      const audio = this.$refs.backgroundMusic;
      if (audio) {
        audio.volume = 0.3;
        audio.play().then(() => {
          this.isPlaying = true;
          console.log('背景音乐自动播放成功');
        }).catch(error => {
          console.log('自动播放失败，需要用户交互:', error);
        });
      }
    },
    handleUserInteraction() {
      if (this.audioContext && this.audioContext.state === 'suspended') {
        this.audioContext.resume().then(() => {
          if (!this.isPlaying) {
            this.tryAutoPlay();
          }
        }).catch(() => { });
      }
    },
    selectNavItem(itemId) {
      this.currentNavItem = itemId
    },
    togglePlayPause() {
      const audio = this.$refs.backgroundMusic;
      if (audio) {
        if (audio.paused) {
          if (this.audioContext && this.audioContext.state === 'suspended') {
            this.audioContext.resume().then(() => {
              this.playMusic(audio);
            }).catch(() => {
              this.playMusic(audio);
            });
          } else {
            this.playMusic(audio);
          }
        } else {
          audio.pause();
          this.isPlaying = false;
        }
      }
    },
    playMusic(audio) {
      audio.volume = 0.3;
      audio.play().then(() => {
        this.isPlaying = true;
        console.log('背景音乐播放成功');
      }).catch(error => {
        console.error('播放失败:', error);
      });
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  width: 100%;
  height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  /* touch-action: pan-x; */
}

.index-container {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  width: 100%;
  min-width: max-content;
  box-sizing: border-box;
}

.left-nav {
  width: 300px;
  flex-shrink: 0;
  height: 100vh;
}

.main-content {
  flex: 1;
  min-width: calc(100vw - 300px);
  height: 100vh;
  background-color: #e4e9f5;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 20px;
  box-sizing: border-box;
}

.content-area {
  text-align: left;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  box-sizing: border-box;
}

.content-area h2 {
  color: #ffa117;
  border-bottom: 2px solid #ffa117;
  padding-bottom: 10px;
  margin-bottom: 30px;
  font-size: 32px;
}

.image-container {
  text-align: center;
  margin: 30px 0;
}

.image-container img {
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

.description {
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 30px;
  padding: 20px;
  background-color: rgba(255, 161, 23, 0.1);
  border-radius: 12px;
  border-left: 4px solid #ffa117;
}

.details {
  margin-top: 30px;
}

.details h3 {
  color: #ffa117;
  margin-bottom: 20px;
  font-size: 24px;
}

.details ul {
  list-style-type: none;
  padding: 0;
}

.details li {
  padding: 12px 0;
  border-bottom: 1px dashed #ccc;
  font-size: 16px;
}

.details li:last-child {
  border-bottom: none;
}

.details strong {
  color: #333;
  margin-right: 8px;
}

.empty-content {
  text-align: center;
  padding: 60px;
  color: #888;
}

.empty-content i {
  font-size: 64px;
  margin-bottom: 20px;
  color: #ccc;
}

.empty-content p {
  font-size: 18px;
}
</style>